module.exports = __webpack_public_path__ + "img/add-to-home-screen-apple-iphone-menu.44ed4595.jpg";